require('whatwg-fetch');

(() => {
  if (!process.env.REACT_APP_MICRO_SERVICE || process.env.REACT_APP_MICRO_SERVICE === 'hybrid') {
    // we only render the standalone app when bundle was loaded from the standalone index.html
    if (document.getElementById('standalone')) {
      require('./standalone');
      return;
    }
  }

  if (process.env.REACT_APP_MICRO_SERVICE && process.env.NODE_ENV === 'production') {
    // production mode has mini-css-extract-plugin generate a main.css file that we should inject
    // eslint-disable-next-line import/no-webpack-loader-syntax
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href =
      (global.__webpack_hubs_public_path__ || global.__webpack_public_path__) +
      '/static/css/main.css';
    const target = document.querySelector('head');
    target.appendChild(link);
  }
})();

export default require('./CollegeProfile');
